'use client'

import { ToastContainer } from 'react-toastify'
import { LayoutProvider } from '../../context/useLayoutContext'
import { NotificationProvider } from '../../context/useNotificationContext'
const AppProvidersWrapper = ({ children }) => {
  return (
    <LayoutProvider>
      <NotificationProvider>
        {children}
        <ToastContainer theme="colored" />
      </NotificationProvider>
    </LayoutProvider>
  )
}
export default AppProvidersWrapper
